import './pill.scss'

export type PillProps = {
  text: string
  status: 'SUCCESS' | 'NEUTRAL' | 'ERROR'
}

const CLASS_NAME = `pill`

export const Pill = (props: PillProps) => {
  return (
    <div className={`${CLASS_NAME}`} data-state={props.status} aria-live={'polite'}>
      {props.text}
    </div>
  )
}
